import React from 'react';

import Button from '../../library/button/button';
import Typography from '../../library/typography/typography';

import { Maybe } from '../../shared/types/graphql-types';

import './product-title.scss';

interface ProductTitleProps {
  brand?: Maybe<string>;
  className?: string;
  link?: Maybe<string>;
  name?: Maybe<string>;
  onClick?: (event: React.SyntheticEvent) => void;
  size?: Maybe<string>;
}

function ProductTitle(props: ProductTitleProps) {
  const { brand, className, link, name, onClick, size } = props;

  if (!brand && !name && !size) {
    return null;
  }

  const children = (
    <>
      {brand && (
        <Typography
          className="product-title__brand"
          styleName="brand"
          tag="span"
          variant="H6"
        >
          {brand}
        </Typography>
      )}

      {name && (
        <Typography
          className="product-title__name"
          styleName="name"
          tag="span"
          variant="H4"
          weight="black"
        >
          {name}
        </Typography>
      )}

      {size && (
        <Typography className="product-title__size" styleName="size" tag="span">
          {size}
        </Typography>
      )}
    </>
  );

  if (link || typeof onClick === 'function') {
    return (
      <Button
        className={`${className || ''} product-title`}
        href={link || ''}
        onClick={onClick}
        styleName="container"
      >
        {children}
      </Button>
    );
  } else {
    return (
      <div className={`${className || ''} product-title`} styleName="container">
        {children}
      </div>
    );
  }
}

export default ProductTitle;
